<template>
  <div>
    <b-sidebar
      :id="sbId"
      :visible="sbModel"
      right
      shadow
      @change="handleSideBarChange"
    >
      <template #title>
        <chat-sidebar-title
          :comm-with="commWith"
          :heartbeats="heartBeatsAll"
          :selected-heart-beat="selectedHeartBeat"
          @heartbeat-selected="handleHeartBeatSelect"
        />
      </template>
      <template #header-close>
        <close-button @close-button-click="handleCloseSideBar" />
      </template>
      <chat-sidebar-body
        v-if="profile"
        :profile="profile"
        :message-box-ref-id="messageBoxRefId"
        :comm-with="commWith"
        :heartbeats="heartBeatsAll"
        :messages="sortedMessages"
        :selected-heart-beat="selectedHeartBeat"
        @activate-tab="handleActivateTab"
      />
      <template v-if="activeTabIdx === 0" #footer>
        <chat-sidebar-footer
          :message-box="messagesBox"
          @submit-text="handleSubmitText"
        />
      </template>
    </b-sidebar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
import CloseButton from "@/components/common/closeButton";
import ChatSidebarTitle from "./title";
import ChatSidebarBody from "./body";
import ChatSidebarFooter from "./footer";
export default {
  name: "Chat_SideBar",
  components: {
    ChatSidebarTitle,
    ChatSidebarBody,
    ChatSidebarFooter,
    CloseButton
  },
  props: {
    sbId: {
      type: String,
      required: true
    },
    sbModel: {
      type: Boolean,
      required: true
    },
    profile: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    commWith: {
      type: String, //iona | heartbeat | enterprise
      required: true
    }
  },
  created() {
    this.getListHeartbeats();
  },
  mounted() {
    this.messagesBox = this.$refs[this.messageBoxRefId];
    const db = firebase.firestore(); //Move to single place
    let discussionId = "sideBar";
    let uid = this.profile.userId;

    this.collectionRef = db.collection(
      `users/${uid}/discussions/${discussionId}/messages`
    );
    this.unsub = this.collectionRef.onSnapshot(snapshot => {
      this.messages = [];
      snapshot.docs.forEach(doc => {
        this.messages.push({ ...doc.data(), id: doc.id });
      });
      //this.scrollToBottom();
    });
  },
  computed: {
    ...mapGetters({
      heartbeats: "user/heartbeats"
    }),
    sortedMessages() {
      let _messages = this.messages;
      return _messages && Array.isArray(_messages)
        ? _messages.sort((a, b) => {
            if (
              a._created_at &&
              b._created_at &&
              a._created_at.seconds &&
              b._created_at.seconds
            ) {
              this.momentTest = a._created_at.seconds;
              return a._created_at.seconds - b._created_at.seconds;
            }
            return false;
          })
        : [];
    },
    heartBeatsAll() {
      const myHeartBeat =
        this.profile && this.profile.heartbeat
          ? this.createHeartBeatObj(this.profile.heartbeat)
          : null;
      return myHeartBeat
        ? [...this.heartbeats, ...[myHeartBeat]]
        : this.heartbeats;
    }
  },
  methods: {
    initMessaging() {
      if (this.selectedHeartBeat && this.selectedHeartBeat.uid) {
        const db = firebase.firestore();
        if (this.unsub) this.unsub(); //Move to single place
        let discussionId = "chat_all";
        //names of fam- more advanced level
        let uid = this.selectedHeartBeat.uid;
        //this.messageBox = document.getElementById('message-box')
        this.collectionRef = db.collection(
          `users/${uid}/heartbeat/${discussionId}/messages`
        );

        this.unsub = this.collectionRef.onSnapshot(snapshot => {
          this.messages = [];
          snapshot.docs.forEach(doc => {
            this.messages.push({ ...doc.data(), id: doc.id });
          });
          // this.$refs['message-box'].scrollIntoView({ behavior: "smooth", block: "end" });
        });
      }
    },
    getListHeartbeats() {
      this.$store
        .dispatch("user/getListHeartbeats", {})
        .then(res => {})
        .catch(e => {});
    },
    handleHeartBeatsClick() {
      this.$refs["heartbeats-popover"].$emit("open");
    },
    handleHeartBeatSelect(selectedHeartBeat) {
      this.selectedHeartBeat = selectedHeartBeat;
      this.initMessaging();
      this.$refs["heartbeats-popover"].$emit("close");
    },
    async handleSubmitText(text) {
      this.text = "";
      this.messages.push(this.createTempPromptMessage(text));
      if (text && text.length > 0) {
        await this.collectionRef.add({
          _created_at: new Date(),
          _created_by:
            this.profile && this.profile.userId ? this.profile.userId : null,
          prompt: text
        });
      }
    },
    createTempPromptMessage(message) {
      return {
        _created_at: new Date(),
        _created_by:
          this.profile && this.profile.userId ? this.profile.userId : null,
        prompt: message
      };
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.$emit("close-clicked");
    },
    handleSideBarChange(isSideBarOpen) {
      if (isSideBarOpen) {
        // this.scrollToBottom();
      }
    },
    /* FEEDBACK MODAL @TODO- move to a component */
    handleShowFeedBackModal() {
      this.$emit("show-feedback-modal", "iona");
    },
    createHeartBeatObj(thisHeartBeat) {
      return {
        _created_at: thisHeartBeat._created_at
          ? thisHeartBeat._created_at
          : null,
        imgURL: this.profile.imgURL ? this.profile.imgURL : null,
        name: "Me",
        slug: thisHeartBeat.profileName ? thisHeartBeat.profileName : null,
        uid: this.profile.userId ? this.profile.userId : null
      };
    },
    handleActivateTab(tabIdx) {
      debugger;
      this.activeTabIdx = tabIdx;
    }
  },
  watch: {
    messages(newVal) {
      if (newVal && Array.isArray(newVal) && newVal.length > 0) {
        //this.scrollToBottom();
      }
    }
  },
  data() {
    return {
      activeTabIdx: 0,
      selectedHeartBeat: null,
      messagesBox: null,
      sidebarFooterHeight: 3000,
      messageBoxRefId: "message-box",
      momentTest: null,
      collectionRef: null,
      unsub: null,
      messages: [],
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 40,
        height: 40,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.header__modal {
  position: relative;
  padding-bottom: 8px;
  margin-bottom: 10px;
  &.border-none::after {
    content: none !important;
  }
  .ico {
    position: absolute;
    top: 5px;
    right: 13px;
    cursor: pointer;
  }
  .ico__search {
    right: unset !important;
    left: 13px;
  }
  h3 {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 49px;
    text-align: center;

    color: #5b606c;
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    width: 100%;
    border-bottom: 1px solid #e4e6eb;
  }
}
.body__tools {
  height: 100%;
  .filter {
    display: flex;
    align-items: center;
    margin-top: 20px;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #5b606c;
      width: 160px;
      margin: 0;
    }
    .filters {
      height: 45px;
      display: flex;
      align-items: center;
      max-width: 100%;
      overflow-x: scroll;
      &::-webkit-scrollbar {
        height: 0px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        // border-radius: 16px;
      }
      .filter_ {
        cursor: pointer;
        padding: 8px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        background-color: #fff;
        color: #5b606c;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 32px;
        margin-right: 16px;
        &.active {
          background: rgba(85, 126, 251, 0.1);
          color: var(--theme-color);
          box-shadow: none;
        }
      }
    }
  }
  .tool__wrapper {
    padding: 32px 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 24px 12px;
    max-height: 530px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 5px;
      margin-right: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 16px;
    }
  }
  .tool {
    cursor: pointer;
    position: relative;
    border-radius: 5px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .tool-event {
      padding: 18px;
      & > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .video {
      position: absolute;
      top: 22px;
      right: 18px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #474d52;
      margin-top: 10px;
      margin-bottom: 0;
    }
    h4 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #000000;
      margin-bottom: 0;
      margin-left: 10px;
    }
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .check {
      display: none;
    }
    &.active {
      .check {
        display: block !important;
      }
      .video {
        display: none !important;
      }
      background-color: #e8eaf9;
    }
  }
  .description__wraper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    img {
      margin-bottom: 34px;
      height: 48px;
      width: 48px;
    }
    h3 {
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin-bottom: 34px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;

      color: #5b606c;
    }
    .btn-add-crew {
      margin-top: 80px;
      margin-bottom: 30px;
    }
  }
}
.toggle-button {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;
    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
.wrapper {
  overflow: auto;
  height: 100%;
}
</style>
